<template>
  <div class="modal-body payment-step">
    <div class="registration-errors" v-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div>

    <h5 class="payment-header-hint" v-if="basket.settings.instalmentPayments && basket.order.summary.total_price >= 50">
      Pay now with credit card or select "Affirm" to view installment options
    </h5>

    <div id="payment-item">

      <form id="modal-payment-form" @submit.prevent="handleSubmit">
        <div class="card">
          <div class="card-header payment-method-header">
            <div class="payment-method-checkbox-wrapper">
              <event-radio
                v-show="basket.settings.instalmentPayments && basket.order.summary.total_price >= 50"
                label="Credit Card"
                v-model="selectedPaymentType"
                name="payment_type"
                data-value="card"
                style="margin-bottom: 0;"
                @input="updatePaymentType"
              ></event-radio>
              <h6 v-show="!(basket.settings.instalmentPayments && basket.order.summary.total_price >= 50)">Credit Card</h6>

              <stripe-logos-header />
            </div>
          </div>

          <div v-show="selectedPaymentType === 'card'" class="card-body p-3 payment-method-block" id="card-stripe-form">
            <div v-show="expressAvailable">
              <div id="express-checkout-element"></div>
              <div class="express-divider"><span>or pay with card</span></div>
            </div>
            <div id="card-element"></div>
          </div>

<!--          <div v-show="basket.settings.offlinePayments" class="offline-header payment-method-header">-->
<!--            <div class="payment-method-checkbox-wrapper">-->
<!--              <event-radio-->
<!--                label="Offline Credit Card"-->
<!--                v-model="selectedPaymentType"-->
<!--                name="payment_type"-->
<!--                data-value="offline"-->
<!--                style="margin-bottom: 0;"-->
<!--                @input="updatePaymentType"-->
<!--              ></event-radio>-->

<!--              <stripe-logos-header />-->
<!--            </div>-->
<!--          </div>-->

          <div v-show="basket.settings.instalmentPayments && basket.order.summary.total_price >= 50">
            <div class="card-footer payment-method-header affirm-wrapper">
              <div class="payment-method-checkbox-wrapper">
                <event-radio
                  label="Affirm - Buy now Pay later"
                  v-model="selectedPaymentType"
                  name="payment_type"
                  data-value="affirm"
                  style="margin-bottom: 0;"
                  @input="updatePaymentType"
                ></event-radio>

                <div class="payment-method payment-method-logos">
                  <!-- Affirm -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="24"
                       viewBox="0 0 38 24" role="img" fill="none"
                       aria-labelledby="pi-affirm"><title id="pi-affirm">
                    Affirm</title>
                    <path opacity=".07"
                          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                          fill="#000"/>
                    <path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z"
                          fill="#fff"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M5.968 16.938c-.37 0-.56-.183-.56-.484 0-.56.625-.748 1.764-.869 0 .746-.505 1.352-1.207 1.352h.003zm.49-4.197c-.814 0-1.75.383-2.258.788l.464.98c.408-.373 1.066-.692 1.66-.692.566 0 .878.189.878.57 0 .255-.207.385-.597.436C5.145 15.012 4 15.415 4 16.54c0 .892.635 1.431 1.627 1.431.708 0 1.338-.393 1.638-.91v.77h1.32v-3.226c0-1.33-.923-1.867-2.126-1.867v.003zM19.708 12.886v4.94h1.413v-2.38c0-1.131.684-1.464 1.161-1.464.215-.002.425.06.604.179l.259-1.306a1.6 1.6 0 00-.63-.114c-.726 0-1.183.321-1.484.975v-.83h-1.323zM29.69 12.74c-.746 0-1.305.442-1.595.867-.27-.55-.84-.866-1.526-.866-.746 0-1.264.414-1.502.892v-.747h-1.363v4.939h1.414v-2.543c0-.91.478-1.35.924-1.35.404 0 .775.26.775.934v2.959h1.411v-2.543c0-.924.467-1.35.933-1.35.374 0 .77.27.77.925v2.968h1.412V14.41c0-1.11-.747-1.67-1.65-1.67M16.27 12.886h-1.279v-.502c0-.654.373-.84.694-.84.22.003.435.057.63.157l.436-.996s-.442-.288-1.245-.288c-.902 0-1.929.509-1.929 2.106v.363h-2.138v-.502c0-.654.372-.84.694-.84.22 0 .436.054.63.157l.435-.996c-.26-.152-.677-.288-1.244-.288-.902 0-1.929.509-1.929 2.106v.363h-.817v1.089h.82v3.85h1.41v-3.85h2.142v3.85h1.411v-3.85h1.28v-1.09z"
                          fill="#101820"/>
                    <path d="M18.523 12.886h-1.41v4.937h1.41v-4.937z"
                          fill="#101820"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M17.165 12.046h1.381c.806-2.533 3.54-4.76 6.79-4.76 3.954 0 7.37 3.01 7.37 7.696.012.962-.12 1.92-.392 2.843h1.34l.014-.046c.226-.914.337-1.852.332-2.793C34 9.761 30.192 6 25.339 6c-3.812 0-7.21 2.646-8.173 6.048v-.002z"
                          fill="#4A4AF4"/>
                  </svg>
                </div>
              </div>
            </div>

            <div v-show="selectedPaymentType === 'affirm'" class="card-body p-3 payment-method-block" id="affirm-element">
              <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="163" height="80.9"
                     viewBox="-252.3 356.1 163 80.9"
                     enable-background="new -252.3 356.1 163 80.9">
                  <path stroke="#B2B2B2" stroke-width="2" stroke-miterlimit="10"
                        d="M-108.9 404.1v30c0 1.1-.9 2-2 2h-120.1c-1.1 0-2-.9-2-2v-75c0-1.1.9-2 2-2h120.1c1.1 0 2 .9 2 2v37m-124.1-29h124.1"
                        fill="none"/>
                  <circle fill="#B2B2B2" cx="-227.8" cy="361.9" r="1.8"/>
                  <circle fill="#B2B2B2" cx="-222.2" cy="361.9" r="1.8"/>
                  <circle fill="#B2B2B2" cx="-216.6" cy="361.9" r="1.8"/>
                  <path stroke="#B2B2B2" stroke-width="2" stroke-miterlimit="10"
                        d="M-128.7 400.1h36.7m-3.6-4.1l4 4.1-4 4.1" fill="none"/>
                </svg>
              </div>
              <div class="text-center">
                <small>After clicking “Pay now”, you will be redirected to Affirm - Pay Over Time to complete your purchase securely.</small>
              </div>
            </div>
          </div>

        </div>

        <button id="submit" type="submit" class="btn btn-pay-now" :disabled="loading">
          <span v-show="loading"><i class="fa-regular fa-spinner fa-spin"></i></span>
          <span v-show="selectedPaymentType !== 'offline'"></span> Pay Now
        </button>
      </form>

      <div v-if="canPayLater" class="pay-later-section">
        <div class="pay-later-divider">
          <span>or</span>
        </div>

        <div class="pay-later-card">
          <button
            type="button"
            class="btn btn-pay-now w-100 pay-later-btn"
            :disabled="loading"
            @click="handlePayLater"
            style=""
          >
            <span v-show="loading"><i class="fa-regular fa-spinner fa-spin"></i></span>
            <span v-show="!loading" style="font-weight: 400 !important; font-size: 1rem !important;">I’ll be Paying with a Check or Purchase Order</span>
          </button>

          <div class="pay-later-subtitle">
            Your spot is reserved immediately. You'll receive payment instructions after registration.
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { loadStripe } from "@stripe/stripe-js";
import { mountExpressCheckout } from "../../../global-declare-components/helpers/stripeExpressCheckout";
import StripeLogosHeader from "./StripeLogosHeader";

export default {
  components: {
    StripeLogosHeader
  },
  async mounted() {
    await this.initializeStripe();
    await this.initializeCardElement();
    this.mountWallets(this.paymentInfo.client_secret);
  },
  beforeDestroy() {
    this.destroyWallets();

    if (this.cardElement) {
      this.cardElement.destroy();
    }

    if (this.affirmElement) {
      this.affirmElement.destroy();
    }
  },
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "paymentInfo",
      "basket",
      "slug",
      "tickets",
      "attendees",
      "errorMessage",
      "basketToken"
    ]),

    canPayLater() {
      return Boolean(
        this.showOffline ||
        (this.basket && this.basket.settings && this.basket.settings.offlinePayments)
      );
    }
  },
  data() {
    return {
      stripe: null,
      elements: null,
      cardElement: null,
      expressCheckout: null,
      expressAvailable: false,
      affirmElement: null,
      showAffirm: false,
      showOffline: false,
      loading: false,
      errorMessage: '',
      selectedPaymentType: 'card',
    }
  },
  methods: {
    ...mapActions('basketStore', ['fetchPaymentInfo', 'confirmSuccessPayment']),

    async initializeCardElement() {
      if (this.cardElement) {
        this.cardElement.unmount();
        this.cardElement = null;
      }
      this.cardElement = this.elements.create('payment', {
        fields: {
          billingDetails: {
            name: 'never',
            email: 'never',
          }
        },
        // Wallets live in the Express Checkout Element above the form, so the
        // Payment Element must not offer them again as tabs.
        wallets: {
          applePay: 'never',
          googlePay: 'never',
        }
      });
      this.cardElement.mount('#card-element');
    },

    async initializeAffirmElement() {
      const currency = this.basket.options.currency.toLowerCase();
      const amountInCents = Math.round(this.basket.order.summary.total_price * 100);

      if (
        !this.showAffirm ||
        !this.basket.settings.instalmentPayments ||
        this.basket.order.summary.total_price < 50
      ) {
        return; // not initializing Affirm, if checks above
      }

      if (this.affirmElement) {
        this.affirmElement.unmount();
      }

      this.affirmElement = this.elements.create('affirmMessage', {
        amount: amountInCents,
        country: 'US',
        currency: currency.toUpperCase(),
      });
      this.affirmElement.mount('#affirm-element');
    },

    async updatePaymentType() {
      const data = {};
      if (this.selectedPaymentType === 'affirm') {
        data.affirm = true;
      }
      if (this.selectedPaymentType === 'offline') {
        data.offline = true;
      }

      // console.log(this.selectedPaymentType);
      await this.fetchPaymentInfo(data); // update client_secret

      // The Elements group is rebuilt against a fresh client secret, so the
      // wallet element bound to the old group has to go first.
      this.destroyWallets();

      this.elements = this.stripe.elements({
        clientSecret: this.paymentInfo.client_secret,
        loader: 'always'
      });

      if (!this.stripe || !this.elements) {
        await this.initializeStripe(); // first init
      }

      if (this.selectedPaymentType === 'card') {
        // this.$nextTick(() => {
        await this.initializeCardElement();
        // });
        this.mountWallets(this.paymentInfo.client_secret);
      } else if (this.selectedPaymentType === 'affirm') {
        await this.initializeAffirmElement();
      }
    },

    async initializeStripe() {
      // Gate on stripe_account alone: the PaymentIntent is created on the
      // connected account whenever one exists, so also requiring `destination`
      // (the external bank account) meant an organization without a payout
      // account initialised Stripe.js on the platform and got
      // "No such payment_intent". `destination` is not a valid loadStripe
      // option either, so it is gone.
      let stripePromise;
      if (this.paymentInfo.stripe.stripe_account) {
        stripePromise = loadStripe(this.paymentInfo.stripe.public_key, {
          stripeAccount: this.paymentInfo.stripe.stripe_account
        });
      } else {
        stripePromise = loadStripe(this.paymentInfo.stripe.public_key);
      }
      this.stripe = await stripePromise;

      this.elements = this.stripe.elements({
        clientSecret: this.paymentInfo.client_secret,
        loader: 'always'
      });

      this.showAffirm = this.paymentInfo.show_affirm;
      this.showOffline = this.paymentInfo.show_offline;
    },

    /**
     * Apple Pay / Google Pay buttons.
     *
     * This replaces a `paymentRequestButton` that had no `paymentmethod`
     * listener: the wallet sheet opened and the payment was never confirmed.
     * The Express Checkout Element confirms through the same PaymentIntent and
     * the same `confirmSuccessPayment` call the card form uses.
     */
    mountWallets(clientSecret) {
      this.destroyWallets();

      this.expressCheckout = mountExpressCheckout({
        stripe: this.stripe,
        elements: this.elements,
        selector: '#express-checkout-element',
        clientSecret,
        returnUrl: this.paymentInfo.redirect_url,
        onConfirm: () => this.confirmSuccessPayment(),
        onError: (message) => { this.errorMessage = message; },
        onAvailable: (available) => { this.expressAvailable = available; },
        onBusy: (busy) => { this.loading = busy; },
      });
    },

    destroyWallets() {
      this.expressAvailable = false;

      if (this.expressCheckout) {
        this.expressCheckout.destroy();
        this.expressCheckout = null;
      }
    },

    async handleSubmit() {
      // Захист від подвійного виклику
      if (this.loading) {
        return;
      }

      const paymentMethodData = {
        billing_details: {
          name: this.paymentInfo.customer.full_name,
          email: this.paymentInfo.customer.email
        }
      };

      this.loading = true;
      this.errorMessage = '';

      try {
        if (this.selectedPaymentType === 'card') {
          const {error, paymentIntent} = await this.stripe.confirmPayment({
            elements: this.elements,
            confirmParams: {
              return_url: this.paymentInfo.redirect_url,
              payment_method_data: paymentMethodData
            },
            redirect: 'if_required'
          });

          if (error && error.message) {
            this.errorMessage = error.message;
          } else {
            if (paymentIntent) {
              await this.confirmSuccessPayment();
            }
          }
        } else if (this.selectedPaymentType === 'affirm') {
          const {error, paymentIntent} = await this.stripe.confirmAffirmPayment(this.paymentInfo.client_secret, {
            return_url: this.paymentInfo.redirect_url
          });

          if (error && error.message) {
            this.errorMessage = error.message;
          } else {
            if (paymentIntent) {
              await this.confirmSuccessPayment();
            }
          }
        }
      } finally {
        this.loading = false;
      }
    },

    async handlePayLater() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.errorMessage = '';

      try {
        await this.fetchPaymentInfo({offline: true}); // update client_secret
        await this.confirmSuccessPayment(true);
      } catch (err) {
        this.errorMessage = err?.response?.data?.message || this.errorMessage || 'Unable to prepare offline payment.';
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.form-group .control-label {
  font-weight: 400;
}

:deep(.fv-help-block) {
  font-family: sans-serif;
  font-weight: 700;
  color: #dc3545 !important;
  font-size: 16px;
}

.pay-later-section {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 10px;
}

.pay-later-divider {
  display: flex;
  align-items: center;
  margin: 16px 0 5px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 13px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }

  span {
    padding: 0 10px;
  }
}

.pay-later-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.pay-later-subtitle {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.4;
  text-align: center;
}

.btn-pay-now {
  font-family: 'Roboto', serif !important;
}

.express-divider {
  display: flex;
  align-items: center;
  margin: 18px 0;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }

  span { padding: 0 10px; }
}

.pay-later-btn {
    font-family: 'Roboto', serif;
    color: #fff;
    background-color: #0062cc;
    border-color: #005cbf;
}
.pay-later-btn:active:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}
</style>
